import styled from "styled-components";

export const BotChatStreamingMessageCloud =
  styled.div`
    ${((props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.messageCloud?.styles)}

    p {
      font-size: inherit;
      line-height: inherit;
    }
  `;
